export default __webpack_public_path__ + "static/media/milestone.098ea7a6.svg";